import { envs } from '../Environments';

let cachedToken: string | null = null;
let tokenPromise: Promise<string | null> | null = null;

export const fetchCsrfToken = async (): Promise<string> => {
  if (cachedToken) {
    return cachedToken;
  }

  if (!tokenPromise) {
    tokenPromise = fetch(`https://app${envs.getEnv()}constantcontact.com/v1/session/ctoken`, {
      headers: {
        accept: 'text/plain,application/json',
      },
      mode: 'cors',
      credentials: 'include',
    }).then((response) => response.headers.get('x-csrf-token'));
  }

  cachedToken = await tokenPromise;

  return cachedToken || '';
};
